import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { A11y, Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import ServiceCard from '../../components/ServiceCard'
import { useAppSelector } from '../../store'
import { AppState } from '../../store/appSlice'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import ShortLeftArrow from '../../assets/icons/JSX/ShortLeftArrow'
import ShortRightArrow from '../../assets/icons/JSX/ShortRightArrow'

const ProductCategorySlider = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  // product categories
  const { data: productCategory, isLoading: isProductCategoryLoading } = api.useGetProductCategoryQuery(undefined)

  const brakePoints = {
    1200: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1350: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1650: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  }

  const MainLoader = isProductCategoryLoading

  return MainLoader ? (
    <Loader />
  ) : (
    <ServiceSection>
      {/* <CloudeIconStyle />
      <ServiceSectionIconStyle /> */}
      <ReplacedContainer>
        <Service>
          <Swiper
            breakpoints={brakePoints}
            slidesPerView="auto"
            scrollbar={{ draggable: true }}
            modules={[Autoplay, A11y, Navigation]}
            loop={productCategory && productCategory?.length > 1}
            navigation={{
              enabled: true,
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            autoplay={{
              delay: 4000,
              pauseOnMouseEnter: true,
              disableOnInteraction: true,
            }}
          >
            {productCategory &&
              productCategory.map((item, index) => {
                //
                const soonText = t('productWillBeAdded')
                //
                return (
                  <Card key={index}>
                    <SwiperSlide key={index}>
                      <ServiceCard
                        key={index}
                        boxAnimation={item.hasActivePromoCode || false}
                        to={item.type === 'travel' ? `/single-select-date` : `/${item.type}/product-detail`}
                        onClick={() => {
                          if (item.type === 'travel') {
                            navigate('/single-select-date')
                          } else {
                            navigate(`/${item.type}/product-detail`)
                          }
                        }}
                        disabled={
                          item.type === 'travel'
                            ? false
                            : item.type === 'tpl'
                            ? false
                            : item.type === 'international-tpl'
                            ? false
                            : item.type === 'welcomer'
                            ? false
                            : item.type === 'pet'
                            ? false
                            : item.type === 'health'
                            ? false
                            : item.type === 'critical'
                            ? false
                            : item.type === 'casco'
                            ? false
                            : item.type === 'property'
                            ? false
                            : true
                        }
                        hideMinPrice={true}
                        img={item.image}
                        itemTitle={item?.translations?.[lang]?.title || ''}
                        itemBody={item?.translations?.[lang]?.body || ''}
                        itemType={`/${item.type}`}
                        bottomText={
                          item.type === 'travel'
                            ? ''
                            : item.type === 'tpl'
                            ? ''
                            : item.type === 'international-tpl'
                            ? ''
                            : item.type === 'welcomer'
                            ? ''
                            : item.type === 'pet'
                            ? ''
                            : item.type === 'health'
                            ? t('showProductDetails')
                            : item.type === 'critical'
                            ? t('showProductDetails')
                            : item.type === 'casco'
                            ? t('showProductDetails')
                            : item.type === 'property'
                            ? t('showProductDetails')
                            : soonText
                        }
                        arrow={
                          item.type === 'travel'
                            ? true
                            : item.type === 'tpl'
                            ? true
                            : item.type === 'international-tpl'
                            ? true
                            : item.type === 'welcomer'
                            ? true
                            : item.type === 'pet'
                            ? true
                            : item.type === 'health'
                            ? true
                            : item.type === 'critical'
                            ? true
                            : item.type === 'casco'
                            ? true
                            : item.type === 'property'
                            ? true
                            : false
                        }
                      />
                    </SwiperSlide>
                  </Card>
                )
              })}
          </Swiper>
          <NavigationButtons>
            <NavButton className="swiper-button-prev">
              <ShortLeftArrow />
            </NavButton>

            <NavButton className="swiper-button-next">
              <ShortRightArrow />
            </NavButton>
          </NavigationButtons>
        </Service>
      </ReplacedContainer>
    </ServiceSection>
  )
}
//
const ReplacedContainer = styled(Container)`
  position: relative;

  ${Responsive.tablet} {
    max-width: unset;
    margin-left: 48px;
    margin-right: unset;
  }

  ${Responsive.mobile} {
    max-width: unset;
    margin-right: unset;
  }
`
const NavButton = styled.div`
  /*  */
`
const NavigationButtons = styled.div`
  .swiper-button-prev,
  .swiper-button-next {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: ${Colors.white};
    box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
    cursor: pointer;

    svg {
      color: ${Colors.nevadaGrey};
      height: 18px;
    }
  }

  ${Responsive.tablet} {
    display: none;
  }

  ${Responsive.mobile} {
    display: none;
  }
`
const Card = styled.div`
  ${Responsive.tablet} {
    max-width: unset;
  }
`
const Service = styled.div`
  width: 100%;
  padding-inline: 96px;

  .swiper-slide {
    height: unset;
  }

  .swiper-button-prev,
  .swiper-button-next {
    z-index: 5 !important;
  }

  .swiper-button-prev::after {
    display: none;
  }
  .swiper-button-next::after {
    display: none;
  }

  ${Responsive.tablet} {
    padding-inline: 0;
    width: 100vw;
    /*  */
    .swiper-slide {
      width: unset;
      margin-right: 24px;
    }

    .service-card {
      width: 296px;
    }
  }

  ${Responsive.mobile} {
    padding-inline: 0;
    width: 100vw;
    /*  */
    .swiper-slide {
      width: unset;
      margin-right: 24px;
    }

    .service-card {
      width: 260px;
    }
  }
`
const ServiceSection = styled.section`
  background-color: ${Colors.Alabaster};
  position: relative;

  ${Responsive.mobile} {
    padding-top: 0;
    padding-bottom: 40px;
  }
`
// const CloudeIconStyle = styled(CloudeIcon)`
//   height: 188px;
//   position: absolute;
//   top: 10px;
//   left: 70px;
//   z-index: 1;

//   /* responsive */
//   ${Responsive.tablet} {
//     display: none;
//   }
//   ${Responsive.mobile} {
//     display: none;
//   }
// `
// const ServiceSectionIconStyle = styled(ServiceSectionIcon)`
//   position: absolute;
//   top: 17px;
//   right: 66px;

//   /* responsive */
//   ${Responsive.tablet} {
//     display: none;
//   }
//   ${Responsive.mobile} {
//     display: none;
//   }
// `
//
export default ProductCategorySlider
